__turbopack_context__.v({
  "ant-slider": "object-pos-audio-props-module__ERlXRa__ant-slider",
  "ant-slider-handle": "object-pos-audio-props-module__ERlXRa__ant-slider-handle",
  "ant-slider-rail": "object-pos-audio-props-module__ERlXRa__ant-slider-rail",
  "ant-slider-track": "object-pos-audio-props-module__ERlXRa__ant-slider-track",
  "cameraBoundsRow": "object-pos-audio-props-module__ERlXRa__cameraBoundsRow",
  "cameraBoundsRowSmall": "object-pos-audio-props-module__ERlXRa__cameraBoundsRowSmall",
  "cameraSettingsRow": "object-pos-audio-props-module__ERlXRa__cameraSettingsRow",
  "castShadowContainer": "object-pos-audio-props-module__ERlXRa__castShadowContainer",
  "colorPickerContainer": "object-pos-audio-props-module__ERlXRa__colorPickerContainer",
  "container": "object-pos-audio-props-module__ERlXRa__container",
  "darkTheme": "object-pos-audio-props-module__ERlXRa__darkTheme",
  "inputContainer": "object-pos-audio-props-module__ERlXRa__inputContainer",
  "inputGroup": "object-pos-audio-props-module__ERlXRa__inputGroup",
  "inputLabel": "object-pos-audio-props-module__ERlXRa__inputLabel",
  "inputNumber": "object-pos-audio-props-module__ERlXRa__inputNumber",
  "inputNumberSmall": "object-pos-audio-props-module__ERlXRa__inputNumberSmall",
  "inputRow": "object-pos-audio-props-module__ERlXRa__inputRow",
  "shadowCameraContent": "object-pos-audio-props-module__ERlXRa__shadowCameraContent",
  "shadowContent": "object-pos-audio-props-module__ERlXRa__shadowContent",
});
